import { Route, Switch, useLocation } from 'react-router';
import React from 'react';
import { MobileRouterPaths } from '../mobileAppConstants';
import MobilePortfolio from '../components/MobilePortfolio/MobilePortfolio';
import MobileAppPrivateRoute from '../components/MobileAppPrivateRoute';
import { Redirect } from 'react-router-dom';
import MobileAppPageNotFound from './MobileAppPageNotFound';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext';
import ErrorBoundary from '../../app/ErrorBoundary';
import MobileAppLoginLoadable from './MobileAppLogin/MobileAppLoginLoadable';
import MobileAppAuthLoadable from './MobileAppAuth/MobileAppAuthLoadable';
import MobileAppForgotPasswordLoadable from './MobileAppForgotPassword/MobileAppForgotPasswordLoadable';
import MobileAppResetPasswordLoadable from './MobileAppResetPassword/MobileAppResetPasswordLoadable';
import MobileAppBrokenLinkLoadable from './MobileAppBrokenLink/MobileAppBrokenLinkLoadable';
import MobileAppConfirmLoadable from './MobileAppConfirm/MobileAppConfirmLoadable';
import MobileMarketLoadable from '../components/MobileMarket/MobileMarketLoadable';
import MobileProfileLoadable from '../components/MobileProfile/MobileProfileLoadable';
import MobileAppFirstStartWrapper from './MobileAppFirstStart/MobileAppFirstStartWrapper';
import MobileAppRegistration from './MobileAppRegistration/MobileAppRegistration';
import { useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../../modules/Location/locationSelectors';
import TradePageLoadable from '../../modules/Trade/TradePageLoadable';
import PromotionsPageLoadable from '../../pages/Promotions/PromotionsPageLoadable';
import ContactsPageLoadable from '../../pages/Contacts/ContactsPageLoadable';
import PrivacyPolicyPageLoadable from '../../pages/PrivacyPolicy/PrivacyPolicyPageLoadable';
import SupportPageLoadable from '../../pages/Support/SupportPageLoadable';
import PartnerPublicDocsLoadable from '../../pages/PartnerPublicDocs/PartnerPublicDocsPageLoadable';
import MobileAppAmazingLoadable from './MobileAppReferralAmazing/MobileAppAmazingLoadable';
import { FEATURES } from '../../app/appConstants';
import AcademyLoadable from '../../modules/Academy/AcademyLoadable';
import MobileAppLeaderboardLoadable from './MobileAppLeaderboard/MobileAppLeaderboardLoadable';
import OnboardingLeaderboardPageLoadable from '../../modules/Leaderboard/Onboarding/OnboardingLeaderboardPageLoadable';

function MobileRoutePage() {
    const location = useLocation<any>();
    const { getLangPath } = useLangContext();
    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);

    return <ErrorBoundary
        from={'app'}
        headerText={getLangPath('error.default_message')}
        linkText={(getLangPath('error.go_back'))}
    >
        <Switch>
            <Route exact path={MobileRouterPaths.auth} component={MobileAppAuthLoadable}/>
            <Route exact path={MobileRouterPaths.brokenLink} component={MobileAppBrokenLinkLoadable}/>
            <Route exact path={MobileRouterPaths.confirm} component={MobileAppConfirmLoadable}/>
            <Route exact path={MobileRouterPaths.contacts} component={ContactsPageLoadable}/>
            <Route exact path={MobileRouterPaths.firstStart} component={MobileAppFirstStartWrapper}/>
            <Route exact path={MobileRouterPaths.forgot} component={MobileAppForgotPasswordLoadable}/>
            <Route exact path={MobileRouterPaths.login} component={MobileAppLoginLoadable}/>
            <Route exact path={MobileRouterPaths.partnerPublicDocs} component={PartnerPublicDocsLoadable}/>
            <Route exact path={MobileRouterPaths.privacyPolicy} component={PrivacyPolicyPageLoadable}/>
            <Route exact path={MobileRouterPaths.promotions} component={PromotionsPageLoadable}/>
            <Route exact path={MobileRouterPaths.registration} component={MobileAppRegistration}/>
            <Route exact path={MobileRouterPaths.reset} component={MobileAppResetPasswordLoadable}/>
            <Route exact path={MobileRouterPaths.support} component={SupportPageLoadable}/>

            <MobileAppPrivateRoute exact path={MobileRouterPaths.default}>
                {
                    isPlatformMobile
                        ? <Redirect to={{
                            pathname: MobileRouterPaths.portfolio,
                            search: location.search,
                            state: location.state,
                        }}/>
                        : <TradePageLoadable/>
                }
            </MobileAppPrivateRoute>
            <MobileAppPrivateRoute path={MobileRouterPaths.academy} feature={FEATURES.ACADEMY}
                                   component={AcademyLoadable}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.portfolioInner} withMenu={false}
                                   component={MobilePortfolio}
                                   withWS={true}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.marketInner} withMenu={false}
                                   component={MobileMarketLoadable} withWS={true}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.profileInner} withMenu={false}
                                   component={MobileProfileLoadable}/>

            <MobileAppPrivateRoute path={MobileRouterPaths.portfolio} component={MobilePortfolio} withWS={true}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.market} component={MobileMarketLoadable} withWS={true}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.profile} component={MobileProfileLoadable}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.referralAmazing} component={MobileAppAmazingLoadable}
                                   withMenu={false} withWS={false}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.leaderboard} component={MobileAppLeaderboardLoadable}
                                   withMenu={false} withWS={true}/>
            <MobileAppPrivateRoute exact withMenu={false}
                                   path={MobileRouterPaths.leaderboardOnboarding}
                                   component={OnboardingLeaderboardPageLoadable}/>
            <Route path="**" component={MobileAppPageNotFound}/>
        </Switch>
    </ErrorBoundary>;
}

export default MobileRoutePage;
